"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchRequest = void 0;
class FetchRequest {
    constructor(args) {
        this.args = args;
    }
    post(path, data, keepalive = false) {
        return __awaiter(this, void 0, void 0, function* () {
            if (fetch) {
                return fetch(`${this.args.baseURL}/${path}`, {
                    keepalive,
                    method: 'POST',
                    mode: 'cors',
                    headers: this.args.headers,
                    body: JSON.stringify(data),
                });
            }
            return null;
        });
    }
}
exports.FetchRequest = FetchRequest;
